import React from 'react';
export function BibleVerseHero() {
  return <section className="w-full bg-[#f5f1ed] py-6 md:py-8" data-id="element-3">
      <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center" data-id="element-4">
        {/* Compact Bible Verse */}
        <p className="font-serif text-sm md:text-base text-[#2d4a3a] italic mb-2" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-5">
          "They opened their treasures and presented to Him gifts of gold,
          frankincense, and myrrh."
        </p>

        {/* Scripture Reference */}
        <p className="text-[#496f58] font-medium text-xs tracking-wide" data-id="element-6">
          — Matthew 2:11 —
        </p>
      </div>
    </section>;
}